import React, { useContext } from "react";
import { withRouter } from "react-router-dom";
import AppContext from "../context/store";
import AuthorityNotFound from "./AuthorityNotFound";
import PlanUpgrade from "./PlanUpgrade";

const AuthContainer = ({ children, authorities, limited_permission, makePlanUpgrade }) => {
  const context = useContext(AppContext);

  // Render logic
  if (makePlanUpgrade && makePlanUpgrade.includes(context.state.company_license.accounting ?? 2)) {
    return <PlanUpgrade />;
  }

  if (authorities) {
    if (authorities.includes(context.state.user.permission)) {
      return children;
    } else if (
      context.state.user.permission === 2 &&
      limited_permission &&
      context.state.limited_permission[limited_permission] > 0
    ) {
      return children;
    } else {
      return <AuthorityNotFound />;
    }
  }

  if (
    limited_permission === undefined ||
    (context.state.user.permission === 2 &&
      limited_permission &&
      context.state.limited_permission[limited_permission] > 0) ||
    context.state.user.permission === 0 ||
    context.state.user.permission === 1
  ) {
    return children;
  }

  return <AuthorityNotFound />;
};

export default withRouter(AuthContainer);
